const listingsMockData = [
    {
        listing: {
            detailPageUrl:
                '/4243170ha?unitId=4649787&adultsCount=1&noDates=true',
            priceSummary: {
                edapEventJson:
                    '{"unituuid":"/units/0000/1dbfdbde-9915-4cae-8de9-2c6166d37438","eventnumadults":"1","eventnumchildren":"0","eventcurrency":"USD","eventpets":"false","stramount":"$82","perioddescription":"avg/night"}',
                formattedAmount: '$82',
                priceAccurate: null,
                pricePeriodDescription: 'avg/night',
                priceTypeId: 'UNKNOWN',
                roundedFormattedAmount: ''
            },
            listingId: '121.4243170.4649787',
            images: [
                {
                    c1_uri:
                        'https://odis-stage.homeaway.com/odis/listing/22f6fd7f-0a3d-4116-9baa-7513f02e3254.c1.jpg',
                    uri:
                        'https://odis-stage.homeaway.com/odis/listing/22f6fd7f-0a3d-4116-9baa-7513f02e3254.c10.jpg'
                },
                {
                    c1_uri:
                        'https://odis-stage.homeaway.com/odis/listing/421f137c-65cc-436b-8788-be7774289e3f.c1.jpg',
                    uri:
                        'https://odis-stage.homeaway.com/odis/listing/421f137c-65cc-436b-8788-be7774289e3f.c10.jpg'
                }
            ],
            averageRating: 5,
            bedrooms: 1,
            propertyType: 'apartment',
            sleeps: 4,
            propertyMetadata: {
                headline: 'Unirii Old Town Apartment'
            },
            reviewCount: 3
        }
    },
    {
        listing: {
            detailPageUrl:
                '/3788240ha?unitId=3803163&adultsCount=1&noDates=true',
            priceSummary: {
                edapEventJson:
                    '{"unituuid":"/units/0000/0c809e4c-fe40-4fa0-9dd1-fdb0a1636b60","eventnumadults":"1","eventnumchildren":"0","eventcurrency":"USD","eventpets":"false","stramount":"$140","perioddescription":"avg/night"}',
                formattedAmount: '$140',
                priceAccurate: null,
                pricePeriodDescription: 'avg/night',
                priceTypeId: 'UNKNOWN',
                roundedFormattedAmount: ''
            },
            listingId: '121.3788240.3803163',
            images: [
                {
                    c1_uri:
                        'https://odis-stage.homeaway.com/odis/listing/df3efaaf-8f77-41bf-bafb-38f208bb6c88.c1.jpg',
                    uri:
                        'https://odis-stage.homeaway.com/odis/listing/df3efaaf-8f77-41bf-bafb-38f208bb6c88.c10.jpg'
                }
            ],
            averageRating: 4.714286,
            bathrooms: {
                full: 1,
                half: 0
            },
            bedrooms: 2,
            propertyType: 'house',
            sleeps: 5,
            petsAllowed: false,
            spaces: {
                spacesSummary: {
                    area: {
                        areaValue: 995
                    }
                }
            },
            propertyMetadata: {
                headline:
                    'Chardonnay Haus: Lakefront Villa on Vineyard, 45 Mins from Downtown Austin'
            },
            reviewCount: 21
        }
    },
    {
        listing: {
            detailPageUrl:
                '/357492ha?unitId=3147914&adultsCount=1&noDates=true',
            priceSummary: {
                edapEventJson:
                    '{"unituuid":"/units/0000/369cabc6-4e23-454f-996d-f4d890a4dc68","eventnumadults":"1","eventnumchildren":"0","eventcurrency":"USD","eventpets":"false","stramount":"$343","perioddescription":"avg/night"}',
                formattedAmount: '$343',
                priceAccurate: null,
                pricePeriodDescription: 'avg/night',
                priceTypeId: 'UNKNOWN',
                roundedFormattedAmount: ''
            },
            listingId: '121.357492.3147914',
            images: [
                {
                    c1_uri:
                        'https://odis-stage.homeaway.com/odis/listing/2d715894-a94e-4ff1-8efb-c2e368f1a809.c1.jpg',
                    uri:
                        'https://odis-stage.homeaway.com/odis/listing/2d715894-a94e-4ff1-8efb-c2e368f1a809.c10.jpg'
                }
            ],
            averageRating: 4.6875,
            bathrooms: {
                full: 2,
                half: 0
            },
            bedrooms: 2,
            propertyType: 'house',
            sleeps: 4,
            petsAllowed: false,
            spaces: {
                spacesSummary: {
                    area: {
                        areaValue: 1100
                    }
                }
            },
            propertyMetadata: {
                headline: '2BR/2BA Historic South Austin Home'
            },
            reviewCount: 32
        }
    },
    {
        listing: {
            detailPageUrl: '/898069?unitId=1446010&adultsCount=1&noDates=true',
            priceSummary: {
                edapEventJson:
                    '{"unituuid":"/units/0004/dc42a847-a76a-4576-9e77-2a82444ef8a4","eventnumadults":"1","eventnumchildren":"0","eventcurrency":"USD","eventpets":"false","stramount":"$80","perioddescription":"avg/night"}',
                formattedAmount: '$80',
                priceAccurate: null,
                pricePeriodDescription: 'avg/night',
                priceTypeId: 'UNKNOWN',
                roundedFormattedAmount: ''
            },
            listingId: '321.898069.1446010',
            images: [
                {
                    c1_uri:
                        'https://odis-stage.homeaway.com/odis/listing/55df86eb-67b0-4be6-ab65-4cdc36bf4d9b.c1.jpg',
                    uri:
                        'https://odis-stage.homeaway.com/odis/listing/55df86eb-67b0-4be6-ab65-4cdc36bf4d9b.c10.jpg'
                }
            ],
            averageRating: 5,
            bathrooms: {
                full: 1,
                half: 0
            },
            bedrooms: 1,
            propertyType: 'apartment',
            sleeps: 2,
            petsAllowed: false,
            spaces: {
                spacesSummary: {
                    area: {
                        areaValue: 861
                    }
                }
            },
            propertyMetadata: {
                headline: 'Florisel C202 - Beach Lovers Apartment'
            },
            reviewCount: 1
        }
    },
    {
        listing: {
            detailPageUrl:
                '/4243170ha?unitId=4649787&adultsCount=1&noDates=true',
            priceSummary: {
                edapEventJson:
                    '{"unituuid":"/units/0000/1dbfdbde-9915-4cae-8de9-2c6166d37438","eventnumadults":"1","eventnumchildren":"0","eventcurrency":"USD","eventpets":"false","stramount":"$82","perioddescription":"avg/night"}',
                formattedAmount: '$82',
                priceAccurate: null,
                pricePeriodDescription: 'avg/night',
                priceTypeId: 'UNKNOWN',
                roundedFormattedAmount: ''
            },
            listingId: '121.4243170.4649787',
            images: [
                {
                    c1_uri:
                        'https://odis-stage.homeaway.com/odis/listing/22f6fd7f-0a3d-4116-9baa-7513f02e3254.c1.jpg',
                    uri:
                        'https://odis-stage.homeaway.com/odis/listing/22f6fd7f-0a3d-4116-9baa-7513f02e3254.c10.jpg'
                }
            ],
            averageRating: 5,
            bathrooms: {
                full: 1,
                half: 0
            },
            bedrooms: 1,
            propertyType: 'apartment',
            sleeps: 4,
            petsAllowed: false,
            spaces: {
                spacesSummary: {
                    area: {
                        areaValue: 592
                    }
                }
            },
            propertyMetadata: {
                headline: 'Unirii Old Town Apartment'
            },
            reviewCount: 3
        }
    },
    {
        listing: {
            detailPageUrl:
                '/357492ha?unitId=3147914&adultsCount=1&noDates=true',
            priceSummary: {
                edapEventJson:
                    '{"unituuid":"/units/0000/369cabc6-4e23-454f-996d-f4d890a4dc68","eventnumadults":"1","eventnumchildren":"0","eventcurrency":"USD","eventpets":"false","stramount":"$343","perioddescription":"avg/night"}',
                formattedAmount: '$343',
                priceAccurate: null,
                pricePeriodDescription: 'avg/night',
                priceTypeId: 'UNKNOWN',
                roundedFormattedAmount: ''
            },
            listingId: '121.357492.3147914',
            images: [
                {
                    c1_uri:
                        'https://odis-stage.homeaway.com/odis/listing/2d715894-a94e-4ff1-8efb-c2e368f1a809.c1.jpg',
                    uri:
                        'https://odis-stage.homeaway.com/odis/listing/2d715894-a94e-4ff1-8efb-c2e368f1a809.c10.jpg'
                }
            ],
            averageRating: 4.6875,
            bathrooms: {
                full: 2,
                half: 0
            },
            bedrooms: 2,
            propertyType: 'house',
            sleeps: 4,
            petsAllowed: false,
            spaces: {
                spacesSummary: {
                    area: {
                        areaValue: 1100
                    }
                }
            },
            propertyMetadata: {
                headline: '2BR/2BA Historic South Austin Home'
            },
            reviewCount: 32
        }
    }
];

export {listingsMockData};
